import { render, staticRenderFns } from "./thirdShopList.vue?vue&type=template&id=6e8e7a88"
import script from "./thirdShopList.vue?vue&type=script&lang=js"
export * from "./thirdShopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports